function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#restaurant_svg__clip0_1_85)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.966 8.873a4.121 4.121 0 004.121-4.122H1.845a4.121 4.121 0 004.12 4.122zm.665 4.705v-2.28c0-.287.211-.525.486-.566 2.74-.54 4.815-2.96 4.815-5.855 0-1.201-.33-3.278-.986-4.877H9.79c.654 1.356 1.078 3.521 1.078 4.877 0 2.702-2.2 4.902-4.902 4.902a4.908 4.908 0 01-4.902-4.902c0-1.257.536-3.482 1.28-4.877h-1.18C.423 1.626 0 3.732 0 4.877a5.976 5.976 0 004.82 5.854c.258.04.459.254.481.518v2.335a.763.763 0 01-.675.76c-2.09.222-3.609.878-3.609 1.656h10.1c0-.805-1.625-1.48-3.82-1.667a.762.762 0 01-.666-.755z",
  fill: "currentColor"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "restaurant_svg__clip0_1_85"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h12v16H0z"
})));

function SvgRestaurant(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgRestaurant;